export const CONFIRMED_GET_LEADS = "CONFIRMED_GET_LEADS";
export const CONFIRMED_GET_TELECALLER_LIST = "CONFIRMED_GET_TELECALLER_LIST";
export const ASSIGN_LEADS_REQUEST = "ASSIGN_LEADS_REQUEST";
export const ASSIGN_LEADS_SUCCESS = "ASSIGN_LEADS_SUCCESS";
export const ASSIGN_LEADS_FAILURE = "ASSIGN_LEADS_FAILURE";
export const CONFIRMED_CREATE_LEAD_ACTION = "CONFIRMED_CREATE_LEAD_ACTION";
export const CONFIRMED_GET_LEAD_DETAILS = "CONFIRMED_GET_LEAD_DETAILS";
export const CONFIRMED_DELETE_LEAD_ACTION = "CONFIRMED_DELETE_LEAD_ACTION";
export const CONFIRMED_EDIT_LEAD_ACTION = "CONFIRMED_EDIT_LEAD_ACTION";

export const CONFIRMED_ADD_LEAD_MARRIAGE_INFO =
  "CONFIRMED_ADD_LEAD_MARRIAGE_INFO";
export const CONFIRMED_ADD_LEAD_ADDRESS_INFO =
  "CONFIRMED_ADD_LEAD_ADDRESS_INFO";
export const CONFIRMED_ADD_LEAD_OTHER_INFO = "CONFIRMED_ADD_LEAD_OTHER_INFO";

// Appointment management actions
export const ADD_APPOINTMENT_TO_LEAD = "ADD_APPOINTMENT_TO_LEAD";
export const UPDATE_APPOINTMENT_IN_LEAD = "UPDATE_APPOINTMENT_IN_LEAD";
export const REMOVE_APPOINTMENT_FROM_LEAD = "REMOVE_APPOINTMENT_FROM_LEAD";
